import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import _ from 'underscore';
import CollectionSlider from "./CollectionSlider";
import {
  getContentsByKey,
} from "../../../shared/utilities/common";
import CmsInlineEdit from "../../Cms/CmsInlineEdit";

const ShadowLeftIcon = require("./icons/shadow-left.png");
const ShadowRightIcon = require("./icons/shadow-right.png");

function Collections(props) {
  const { contents, openDeliveryWidget } = props;
  const [menuItems, setMenuItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(0);
  const tablistRef = useRef(null);

  const heading = _.find(contents, {key: "heading"});
  const collections = getContentsByKey(contents, "collections");

  const getMenu = () => {
    const menu = collections?.map(item => {
      const title = _.find(item.children, {key: "title"});
      return {
        title
      };
    });

    return menu;
  };

  const setSelectedIndex = index => {
    setSelectedItem(index);
  };

  const titleCollection = () => {
    return collections?.map(item => {
      return {
        ...item,
        children: [_.find(item.children, {key: "title"})].filter((c) => c),
      };
    });
  }

  useEffect(() => {
    const menu = getMenu();
    setMenuItems(menu);
  }, [contents]);

  // Focus the selected tab when selection changes (for arrow key navigation)
  useEffect(() => {
    if (tablistRef.current && menuItems.length > 0) {
      const safeTitle = menuItems[selectedItem]?.title?.value?.replace(/\s+/g, '-').toLowerCase() || `tab-${selectedItem}`;
      const selectedTab = tablistRef.current.querySelector(`#tab-${selectedItem}-${safeTitle}`);
      if (selectedTab && document.activeElement !== selectedTab) {
        // Only focus if the user is already interacting with the tablist
        const activeElementInTablist = tablistRef.current.contains(document.activeElement);
        if (activeElementInTablist) {
          selectedTab.focus();
        }
      }
    }
  }, [selectedItem, menuItems]);

  return (
    <div className="w-full flex flex-col items-start lg:items-center gap-4 mt-9 mb-9 border-0">
      <div className="md:max-w-screen-desktop w-full lg:px-0 px-4">
        <h1 className="text-dark dark:text-white font-congenialBlack text-4xl leading-9 tracking-tighter">
          {
            heading &&
            (
              <CmsInlineEdit cmsNode={heading}>
                {heading.value}
              </CmsInlineEdit>
            )
          }
        </h1>
      </div>
      <div className="md:max-w-screen-desktop w-full lg:px-0 px-4 text-dark dark:text-white">
        <CmsInlineEdit type="list" cmsNode={{children: titleCollection()}} showContent={false} showChilds>
          <div
            ref={tablistRef}
            role="tablist"
            aria-label="Product categories"
            className="flex flex-wrap md:flex-nowrap gap-4 md:gap-10 mt-4 font-montserratMedium overflow-x-visible md:overflow-x-auto no-scrollbar ease-in"
          >
            {menuItems &&
              menuItems.map((item, index) => {
                const safeTitle = item.title?.value?.replace(/\s+/g, '-').toLowerCase() || `tab-${index}`;
                return (
                  <button
                    type="button"
                    id={`tab-${index}-${safeTitle}`}
                    role="tab"
                    aria-selected={selectedItem === index}
                    aria-controls={`panel-${index}-${safeTitle}`}
                    tabIndex={selectedItem === index ? 0 : -1}
                    key={item.title?.value}
                    onClick={() => setSelectedIndex(index)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        setSelectedIndex(index);
                      } else if (e.key === 'ArrowRight') {
                        e.preventDefault();
                        const nextIndex = index < menuItems.length - 1 ? index + 1 : 0;
                        setSelectedIndex(nextIndex);
                      } else if (e.key === 'ArrowLeft') {
                        e.preventDefault();
                        const prevIndex = index > 0 ? index - 1 : menuItems.length - 1;
                        setSelectedIndex(prevIndex);
                      } else if (e.key === 'Home') {
                        e.preventDefault();
                        setSelectedIndex(0);
                      } else if (e.key === 'End') {
                        e.preventDefault();
                        setSelectedIndex(menuItems.length - 1);
                      }
                    }}
                    className={`
                  ${
                    index === selectedItem
                      ? " border-dark dark:border-white opacity-100"
                      : " border-transparent opacity-50 "
                  }
                  h-[52px] w-auto cursor-pointer hover:opacity-100
                  hover:font-montserratBold border-b-4 hover:border-dark
                  dark:hover:border-white transition duration-300 ease-in text-lg
                  bg-transparent border-0 p-0
                  `}
                  >
                    <h3 className="m-0 p-0 font-inherit text-inherit">
                      <nobr>{item.title?.value}</nobr>
                    </h3>
                  </button>
                );
              })}
          </div>
        </CmsInlineEdit>
      </div>

      <div className="flex justify-between w-full relative">
        <div className="w-full">
          <CollectionSlider
            data={collections}
            onChange={setSelectedIndex}
            selectedIndex={selectedItem}
            openDeliveryWidget={openDeliveryWidget}
          />
        </div>

        <div className="pointer-events-none lg:block hidden absolute lg:top-0 -translate-x-0 traslate-y-[-50%] left-0">
          <img src={ShadowLeftIcon} alt="" className="opacity-50" />
        </div>

        <div className="pointer-events-none lg:block hidden absolute lg:top-0 -translate-x-0 traslate-y-[-50%] right-0">
          <img
            src={ShadowRightIcon}
            alt=""
            className="opacity-50"
          />
        </div>
      </div>
    </div>
  );
}

Collections.propTypes = {
  contents: PropTypes.shape({}),
  openDeliveryWidget: PropTypes.func
};

Collections.defaultProps = {
  contents: null,
  openDeliveryWidget: null
};

export default Collections;
